import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2 10L10 2",
		stroke: "white",
		strokeWidth: 2.29,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10 10L2 2",
		stroke: "white",
		strokeWidth: 2.29,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCloseIcon;
